<div class="p-8">
  <!-- Header -->
  <div class="flex items-start justify-between mb-8">
    <div>
      <h1 class="text-sm font-bold text-navy-600">Program Configuration</h1>
      <p class="text-xs text-slate-500 mt-1">
        Define programs and their associated taxonomies for incident classification.
      </p>
    </div>
    <button
      type="button"
      (click)="openCreate()"
      class="flex items-center gap-2 bg-accent-500 hover:opacity-90 text-white text-xs font-semibold px-4 py-2.5 rounded-xl transition-opacity cursor-pointer shrink-0"
    >
      <img src="/icons/plus-white-icon.svg" class="w-4 h-4" alt="" />
      Create Program
    </button>
  </div>

  <!-- Filters -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-6">
    <!-- Program Type Toggle -->
    <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-2 gap-1 h-11">
      @for (type of programTypes(); track type.id) {
        <button
          type="button"
          (click)="selectType(type.id)"
          [ngClass]="
            selectedTypeId() === type.id
              ? 'bg-white text-navy-900 shadow-sm'
              : 'text-slate-500 hover:text-navy-700'
          "
          class="px-4 py-2.5 rounded-full text-xs transition-all cursor-pointer"
        >
          {{ type.name }}
        </button>
      }
    </div>

    <!-- Search -->
    <div class="relative flex-1 max-w-xs">
      <img
        src="/icons/search-icon.svg"
        class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
        alt=""
      />
      <input
        type="text"
        placeholder="Filter by Name"
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
        class="w-full pl-9 pr-4"
      />
    </div>
  </div>

  <!-- Table -->
  <div class="bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden">
    <app-data-table
      [columns]="columns"
      [rows]="programs()"
      [total]="total()"
      [page]="pageIndex() + 1"
      [pageSize]="pageSize"
      [loading]="loading()"
      [clickableRows]="true"
      (pageChange)="onPageChange($event)"
      (rowAction)="onRowAction($event)"
    />
  </div>
</div>

@if (showModal()) {
  <app-create-program-modal
    [program]="selectedProgram()"
    (closed)="closeModal()"
    (saved)="closeModal(); load()"
    (removed)="closeModal(); load()"
  />
}

@if (programToDelete()) {
  <app-confirm-modal
    title="Delete Program"
    [message]="
      'Are you sure you want to delete &quot;' +
      programToDelete()!.name +
      '&quot;? This action cannot be undone.'
    "
    confirmLabel="Delete"
    (closed)="programToDelete.set(null)"
    (confirmed)="confirmDelete()"
  />
}
